export
const name: string = "Particles";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec3  a_position;
    attribute vec2  a_tex_coord;
    attribute float a_visibility;

    uniform mat4    u_view_matrix_matrix;
    uniform mat4    u_projection_matrix;
    uniform mat3    u_rotation_matrix;
    uniform vec3    u_cam_pos;

    uniform float   u_radiusX;
    uniform float   u_radiusZ;
    uniform float   u_size;
    uniform float   u_scale;
    uniform float   u_height;
    uniform float   u_elapsedTime;
    uniform float   u_speedH;
    uniform float   u_speedV;
`;

export
const varyings: string = ``;

export
const implementation: string = `
    void main()
    {
        vec3 pos = a_position;

        pos.x += cos((u_elapsedTime + a_position.z + a_position.x) * 0.25 * u_speedH) * u_radiusX;
        pos.y += mod(pos.y - u_elapsedTime * u_speedV, u_height);
        pos.z += sin((u_elapsedTime + a_position.x) * 0.25 * u_speedH) * u_radiusZ;

        vec4 mvPosition = u_view_matrix_matrix * vec4(pos, 1.0);

        gl_PointSize = u_size * (u_scale / length(mvPosition.xyz));
        gl_Position = u_projection_matrix * mvPosition;

    #ifdef LOGDEPTH
        setVaryingsForLogarithmicDepthBuffer();
    #endif
    }
`;
